import { ColumnActionsMode } from '@fluentui/react';

export const queueColumns = [
  {
    key: 'column1',
    name: 'Tire Optix Survey ID',
    fieldName: 'tireOptixSurveyId',
    minWidth: 100,
    maxWidth: 100,
    isResizable: true,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'column2',
    name: 'GLS Survey ID',
    fieldName: 'glsSurveyId',
    minWidth: 75,
    maxWidth: 100,
    isResizable: true,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'column3',
    name: 'Survey Date',
    fieldName: 'surveyDate',
    minWidth: 75,
    maxWidth: 100,
    isResizable: true,
    isSorted: true,
    isSortedDescending: false,
  },
  {
    key: 'column4',
    name: '# of Tires',
    fieldName: 'numberOfTires',
    minWidth: 40,
    maxWidth: 40,
    isResizable: true,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'column5',
    name: '# of Errors',
    fieldName: 'numberOfErrors',
    minWidth: 40,
    maxWidth: 40,
    isResizable: true,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'column6',
    name: '# of No Match',
    fieldName: 'numberOfNoMatch',
    minWidth: 40,
    maxWidth: 40,
    isResizable: true,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'column7',
    name: 'Dispo Code',
    fieldName: 'dispoCode',
    minWidth: 40,
    maxWidth: 40,
    isResizable: true,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'column8',
    name: 'Status',
    fieldName: 'status',
    minWidth: 75,
    maxWidth: 75,
    isResizable: true,
    isSorted: false,
    isSortedDescending: false,
    tooltip: 'Pending: Brand new to Tire Optix, has not been processed yet ' +
    'Complete: Sent over to Post OOS Tires ' +
    'Error: Brands that did not process through OOS screen after submission',
  },
  {
    key: 'column9',
    name: 'Comments',
    fieldName: 'comments',
    minWidth: 100,
    maxWidth: 100,
    isResizable: true,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'column10',
    name: 'Survey By',
    fieldName: 'surveyBy',
    minWidth: 50,
    maxWidth: 50,
    isResizable: true,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'column11',
    name: 'Last Modified By',
    fieldName: 'lastModifiedBy',
    minWidth: 75,
    maxWidth: 75,
    isResizable: true,
    isSorted: false,
    isSortedDescending: false,
  },
  {
    key: 'column12',
    name: 'Date Modified',
    fieldName: 'dateModified',
    minWidth: 50,
    maxWidth: 50,
    isResizable: true,
    isSorted: false,
    isSortedDescending: false,
  },
];

export const pageSizeQueue = [50, 100, 200];

export const showHideQueueColumns = [
  {
    key: 'column1',
    name: 'TO Survey ID',
    fieldName: 'docNum',
    isVisible: true,
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
    exportName: 'DocNum',
  },
  {
    key: 'column2',
    name: 'GLS Survey ID',
    fieldName: 'glsSurveyId',
    isVisible: true,
    isSorted: false,
    isSortedDescending: false,
    exportName: 'GlsSurveyId',
  },
  {
    key: 'column3',
    name: 'Survey Date',
    fieldName: 'surveyDate',
    isVisible: true,
    isSorted: true,
    isSortedDescending: true,
    exportName: 'SurveyDate',

  },
  {
    key: 'column4',
    name: '# Tires',
    fieldName: 'numberOfTires',
    isVisible: true,
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
    exportName: 'NumberOfTires',
  },
  {
    key: 'column5',
    name: '# Errors',
    fieldName: 'numberOfErrors',
    isVisible: true,
    isSorted: false,
    isSortedDescending: false,
    exportName: 'NumberOfErrors',
  },
  {
    key: 'column6',
    name: '# No Match',
    fieldName: 'numberOfNoMatch',
    isVisible: true,
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
    exportName: 'NumberOfNoMatch',
  },
  {
    key: 'column7',
    name: 'Dispo Code',
    fieldName: 'dispoCode',
    isVisible: true,
    isSorted: false,
    isSortedDescending: false,
    exportName: 'DispoCode',
  },
  {
    key: 'column8',
    name: 'Status',
    fieldName: 'status',
    isVisible: true,
    isSorted: false,
    isSortedDescending: false,
    tooltip: 'Pending: Brand new to Tire Optix, has not been processed yet ' +
    'Error: Brands that did not process through OOS screen after submission\n' +
    'Complete: Sent over to Post OOS Tires ',
    exportName: 'Status',
  },
  {
    key: 'column9',
    name: 'Comments',
    fieldName: 'comments',
    isVisible: true,
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
    exportName: 'Comments',
  },
  {
    key: 'column10',
    name: 'Survey By',
    fieldName: 'surveyBy',
    isVisible: true,
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
    exportName: 'SurveyBy',
  },
  {
    key: 'column11',
    name: 'Last Modified By',
    fieldName: 'lastModifiedBy',
    isVisible: true,
    isSorted: false,
    isSortedDescending: false,
    columnActionsMode: ColumnActionsMode.disabled,
    exportName: 'LastModifiedBy',
  },
  {
    key: 'column12',
    name: 'Date Modified',
    fieldName: 'dateModified',
    isVisible: true,
    isSorted: false,
    isSortedDescending: false,
    exportName: 'DateModified',
  },
];

export const mockQueueRecords = [
  {
    tireOptixSurveyId: '07891234001',
    glsSurveyId: '07891234001',
    surveyDate: '2024-10-23',
    numberOfTires: '6',
    numberOfErrors: '0',
    numberOfNoMatch: '0',
    dispoCode: '20',
    status: 'Pending',
    comments: '',
    surveyBy: 'Jeanette',
    lastModifiedBy: 'System',
    dateModified: '2024-10-23',
  },
  {
    tireOptixSurveyId: '01234567891',
    glsSurveyId: '01234567890',
    surveyDate: '2024-10-23',
    numberOfTires: '10',
    numberOfErrors: '0',
    numberOfNoMatch: '0',
    dispoCode: '20',
    status: 'Complete',
    comments: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    surveyBy: 'Jeanette',
    lastModifiedBy: 'System',
    dateModified: '2024-10-23',
  },
  {
    tireOptixSurveyId: '01234567892',
    glsSurveyId: '01234567890',
    surveyDate: '2024-10-23',
    numberOfTires: '10',
    numberOfErrors: '0',
    numberOfNoMatch: '0',
    dispoCode: '20',
    status: 'Error',
    comments: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do',
    surveyBy: 'Jeanette',
    lastModifiedBy: 'System',
    dateModified: '2024-10-23',
  },
  {
    tireOptixSurveyId: '01234567893',
    glsSurveyId: '01234567890',
    surveyDate: '2024-10-23',
    numberOfTires: '10',
    numberOfErrors: '0',
    numberOfNoMatch: '2',
    dispoCode: '20',
    status: 'Complete',
    comments: '',
    surveyBy: 'Jeanette',
    lastModifiedBy: 'System',
    dateModified: '2024-10-23',
  },
];